import React, { useContext } from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import EditIcon from '@mui/icons-material/Edit';
import CodeIcon from '@mui/icons-material/Code';
import { AuthContext } from "../../helpers/AuthContext";
import { isAdministratorRole } from "../../utils/instanceRoleInheritance";
import { Container } from 'react-bootstrap';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SettingsIcon from '@mui/icons-material/Settings';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';

/* REMOVE material-ui node module */

function AppInstanceList({ list }) {
  const { authState } = useContext(AuthContext);
  const [listOfPosts, setListOfPosts] = useState(list);
  let history = useHistory();
  useEffect(() => {
    if (!localStorage.getItem("accessToken")) {
      history.push("/login");
    } else {
      setListOfPosts(list)
    }
  }, [listOfPosts]);
  return (
    listOfPosts.list && listOfPosts.list.length ?
    <div className="app-instance-list">
      { listOfPosts.list.map((value, key) => {
        let customBrandLogo
        if(value.customUploadedBrandLogo != null){
          customBrandLogo = value.customUploadedBrandLogo
        } else {
          customBrandLogo = "/elite-core-brand-logo.png"
        }
        let instanceUniqueId = value.instanceUniqueId
        let activeStatus = value.activeStatus
        let stripeCustomerId = value.stripeCustomerId
        return (

          <>
          { instanceUniqueId != null && activeStatus == "active" ?
          <div key={key} className="instance">
            <div className="instance-inner-container">
            <div className="ec-instance-details">
              <div className="ec-brand-logo-container">
                <div className="ec-icon">
                  <img src={customBrandLogo}/>
                </div>
              </div>
            <div className="instance-heading"> {value.instanceName} </div>
            <div className="instance-type-of-core"><SettingsIcon/> 
              {
              value.typeOfCore == "promo-company" ? "Promo Company" : ""
              } 
            </div>
            {stripeCustomerId != null && stripeCustomerId != "null" ? <span className="instance-badge-activated">Activated</span> : <span className="instance-badge-inactive">Inactive</span> }
            <div className="footer">

            </div>
            </div>
            {isAdministratorRole(authState?.role) ? (
              <div className="iconBar">
                <div className="editBtn" onClick={() => {
                  history.push(`/instance/${instanceUniqueId}`);
                }}>
                  <EditIcon />
                  Access
                </div>
                <div className="codeBtn" onClick={() => {
                  history.push(`/instance/${instanceUniqueId}/settings/global-settings/company-settings`);
                }}>
                  <CodeIcon />
                  Settings
                </div>
              </div>
            ) : (
              <div className="iconBar">
                <div className="editBtn" onClick={() => {
                  history.push(`/instance/${instanceUniqueId}`);
                }}>
                  <EditIcon />
                  Access
                </div>
              </div>
            )}

            </div>
          </div>
          :
          activeStatus == 'payment-failed' ? 
          <div className="instance">
            <div className="instance-inner-container">
            <div className="ec-instance-details">
              <div className="ec-brand-logo-container">
                <div className="ec-icon add-new-instance">
                  <MoneyOffIcon/>
                </div>
              </div>
            <div className="instance-heading"> {value.instanceName}</div>
            <div className="instance-type-of-core">Your live core has been automatically turned off as your attached payment method failed.</div>
            <div className="footer">
                
            </div>
            </div>
            <button className="instance-button payment-failed"><Link to={`/instance/${value.instanceUniqueId}/add-payment-method`}>Manage payment method</Link></button>
            </div>
          </div>
          : 
          <div className="instance get-started">
            <div className="instance-inner-container">
            <div className="ec-instance-details">
              <div className="ec-brand-logo-container">
                <div className="ec-icon add-new-instance">
                  <SupervisedUserCircleIcon/>
                </div>
              </div>
            <div className="instance-heading"> Create support core</div>
            <div className="instance-type-of-core">Your newly launched support agent core is waiting to be used. </div>
            {<span className="instance-badge-step-one">Step #1</span>}
            <div className="footer">
                
            </div>
            </div>
            <button className="instance-button get-started"><Link to={`/instance/${value.id}/get-started`}>Get started</Link></button>
            </div>
          </div>
          }

            </>
        );
      })} 
    </div>
    : ""
  );
}

export default AppInstanceList;
